import { render, staticRenderFns } from "./BannerDetails1.vue?vue&type=template&id=20d3d628&"
import script from "./BannerDetails1.vue?vue&type=script&lang=ts&"
export * from "./BannerDetails1.vue?vue&type=script&lang=ts&"
import style0 from "./BannerDetails1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports